// extracted by mini-css-extract-plugin
export var csatScore = "_kf-5";
export var header = "_kf-1";
export var panelWrapper = "_kf-2";
export var postPreview = "_kf-3";
export var rightContent = "_kf-0";
export var wrappingText = "_kf-4";